export default __webpack_public_path__ + "static/media/iwannina-dimos-logo.0ecc3176.png";